import { NavLink } from "@mantine/core";
import {
  IconActivity,
  IconAlertTriangle,
  IconChevronRight,
  IconBrandBooking,
  IconPicnicTable,
  IconUsersGroup,
  IconSettings,
  IconCalendar,
  IconFileImport,
  IconFile,
  IconDatabase,
  IconLayoutNavbar,
  IconFlame,
  IconTicket,
} from "@tabler/icons-react";
import { RouteHeaderName } from "../skeleton.helper";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAdminOrOwner } from "../../../../redux/selectors/authSelector";
import { selectEnableErrorAlerts } from "../../../../redux/selectors/settingSelector";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isAdminOrOwner = useSelector(selectIsAdminOrOwner);
  const enableErrorAlerts = useSelector(selectEnableErrorAlerts);
  const navBarItems: { label: RouteHeaderName; icon: typeof IconActivity; path?: string }[] = [
    {
      label: RouteHeaderName.Dashboard,
      icon: IconActivity,
    },
    {
      label: RouteHeaderName.Calendar,
      icon: IconCalendar,
    },
    {
      label: RouteHeaderName.Bookings,
      icon: IconBrandBooking,
    },
    {
      label: RouteHeaderName.Settings,
      icon: IconSettings,
    },
    {
      label: RouteHeaderName.BannerSettings,
      icon: IconLayoutNavbar,
      path: 'banner-settings',
    },
    {
      label: RouteHeaderName.VolcanoBannerSettings,
      icon: IconFlame,
      path: 'volcano-banner-settings',
    },
    {
      label: RouteHeaderName.PromoCodes,
      icon: IconTicket,
      path: 'promo-codes',
    },
    {
      label: RouteHeaderName.Content,
      icon: IconBrandBooking,
    },
    {
      label: RouteHeaderName.Users,
      icon: IconUsersGroup,
    },
    {
      label: RouteHeaderName.ImportBookings,
      icon: IconFileImport,
    },
    {
      label: RouteHeaderName.Theaters,
      icon: IconPicnicTable,
    },
    {
      label: RouteHeaderName.Logs,
      icon: IconFile,
    },
    {
      label: RouteHeaderName.Backup,
      icon: IconDatabase,
    },
    {
      label: RouteHeaderName.Alerts,
      icon: IconAlertTriangle,
    },
  ];

  return (
    <>
      {navBarItems.filter((item) => item.label !== RouteHeaderName.Alerts || enableErrorAlerts).map((item, index) => {
        const itemPath = item.path ?? item.label.toLowerCase();
        return (
        <NavLink
          key={index}
          label={item.label}
          leftSection={<item.icon size="1rem" stroke={1.5} />}
          disabled={
            (item.label === RouteHeaderName.Content && !isAdminOrOwner)
            || (item.label === RouteHeaderName.ImportBookings && !isAdminOrOwner)
            || (item.label === RouteHeaderName.Theaters && !isAdminOrOwner)
            || (item.label === RouteHeaderName.Alerts && !isAdminOrOwner)
            || (item.label === RouteHeaderName.Logs && !isAdminOrOwner)
            || (item.label === RouteHeaderName.Backup && !isAdminOrOwner)
            || (item.label === RouteHeaderName.BannerSettings && !isAdminOrOwner)
            || (item.label === RouteHeaderName.VolcanoBannerSettings && !isAdminOrOwner)
            || (item.label === RouteHeaderName.PromoCodes && !isAdminOrOwner)
          }
          rightSection={
            <IconChevronRight
              size="0.8rem"
              stroke={1.5}
              className="mantine-rotate-rtl"
            />
          }
          variant="subtle"
          active={location.pathname?.split('/')?.pop() === itemPath}
          onClick={() => {
            navigate(itemPath);
          }}
          styles={{
            root: {
              borderRadius: "0.5rem",
            },
            label: {
              fontSize: "1rem",
              fontWeight: "bold",
              borderBottom: "1px solid #e0e0e0",
            },
          }}
        />
        );
      })}
    </>
  );
};

export default Navbar;
